import { Toast } from "components/toast";
import api from "api/api";
import { AttendanceActionsTypes } from "contexts/attendance-context/actions-reducer";
import { Dispatch, SetStateAction } from "react";
import { makeEvent } from "services/events";

export async function enviarTelefoneContato(
  telefoneContato: string,
  attendanceId: number,
  setLoading: Dispatch<SetStateAction<boolean>>,
  dispatch: Dispatch<AttendanceActionsTypes>,
  onCloseModalChangeNumber: () => void
) {
  setLoading(true);
  try {
    await api.patch(`/atendimentos/${attendanceId}/telefone-contato`, {
      telefoneContatoRaw: telefoneContato.replace(/\D/g, ""),
    });
    dispatch({
      type: "changeFieldWithInitial",
      payload: {
        fieldName: "telefoneContatoNormalizado",
        data: "55" + telefoneContato.replace(/\D/g, ""),
      },
    });
    makeEvent("clear-whatsapp-chat", null, { throwsError: false });
  } catch (error: any) {
    if (
      error?.response?.data?.message?.includes("not connected with waboxapp")
    ) {
      Toast({
        title: "Não foi possível enviar. WhatsApp desconectado!",
        status: "error",
      });
    } else {
      Toast({
        title: "Erro ao atualizar telefone do contato!",
        status: "error",
      });
    }
    setLoading(false);
    return;
  }
  onCloseModalChangeNumber();
  setLoading(false);
}
